import { useEffect, useState } from "react";

function SafeImage({ src, fallback, ...props }) {
    const [currentSrc, setCurrentSrc] = useState(src);

    useEffect(() => {
        setCurrentSrc(src);
    }, [src]);

    return (
        <img
            {...props}
            src={currentSrc}
            onError={() => setCurrentSrc(fallback)}
        />
    );
}

export default SafeImage;